import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@app/env';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent {
  constructor(private router: Router) {}

  get isIOSApp(): boolean {
    return this.isIOS && environment.isCordova;
  }
  get isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
  }
}
